/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */


export interface ReactSelectOptions {
  value: string | number;
  label: string | number;
  isDisabled?: boolean;
}

export const getOption = (options: ReactSelectOptions[], vd: string, allowCustomOptions?: boolean) => {
  const option = options.find(o => o.value === vd);
  return option ?? { value: vd, label: vd, isDisabled: !allowCustomOptions };
};

export const initCustomOptions = (data: (string | number)[], options: ReactSelectOptions[], allowCustomOptions?: boolean) => {
  return data.reduce((custom, vd) => {
    if (vd === undefined || vd === '') {
      return custom;
    }

    const option = options.find(o => o.value === vd);
    if (!option) {
      custom.push({
        value: vd,
        label: vd,
        isDisabled: !allowCustomOptions
      });
    }
    return custom;
  }, [...options]);
};
